import React from 'react';

/**
 * Removable active-filter chips + a single clear-all + the current result count.
 * Presentational only.
 *
 * Props:
 *   filters:     [{ key, label }]  — the currently applied filters
 *   onRemove:    (key) => void
 *   onClearAll:  () => void
 *   resultCount: number
 */
const FilterChips = ({ filters = [], onRemove, onClearAll, resultCount }) => {
  const hasFilters = filters.length > 0;
  return (
    <div className="uv-chips" data-testid="filter-chips">
      {hasFilters &&
        filters.map((f) => (
          <span className="uv-chip" key={f.key} data-testid={`chip-${f.key}`}>
            {f.label}
            <button
              type="button"
              className="uv-chip__x"
              aria-label={`Remove ${f.label}`}
              onClick={() => onRemove(f.key)}
            >
              ✕
            </button>
          </span>
        ))}
      {hasFilters && (
        <button type="button" className="uv-chip uv-chip--clear" data-testid="clear-all" onClick={onClearAll}>
          Clear all
        </button>
      )}
      {typeof resultCount === 'number' && (
        <span className="uv-chips__count" data-testid="result-count">
          {resultCount.toLocaleString()} {resultCount === 1 ? 'user' : 'users'}
        </span>
      )}
    </div>
  );
};

export default FilterChips;
